import React from "react";
import {useTranslation} from "react-i18next";
// local
import {Modal} from "components/Modal";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";

export const PublicPFPPublishModal = ({onSave, onClose}) => {
  const {t} = useTranslation();

  return (
    <Modal
      titleText="PUBLISH_OPEN_RFT_CONFIRMATION_POPUP_HEADER"
      noTitleIcon
      boldTitle
      width={500}
      rounded
      darked
      noCenterContent
      style={{marginTop: "20vh"}}
      onClose={onClose}
    >
      <div className="procurement-create-edit-modal__content">
        <p>{t("PUBLISH_OPEN_RFT_CONFIRMATION_POPUP_PARAGRAPH_1")}</p>
        <p>{t("PUBLISH_OPEN_RFT_CONFIRMATION_POPUP_PARAGRAPH_2")}</p>
        <div className="df-row-jce-center mt-8">
          <ButtonTransparent
            name="PUBLISH_OPEN_RFT_CONFIRMATION_POPUP_BACKBUTTON"
            onClick={onClose}
            addClass="mr-4"
          />
          <ButtonTransparent
            name="PUBLISH_OPEN_RFT_CONFIRMATION_POPUP_PUBLISHBUTTON"
            onClick={onSave}
          />
        </div>
      </div>
    </Modal>
  );
};
